import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator, MatSidenav, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { LanguageService } from '../../language.service';
import { NotificationDismissed } from '../../models/sensorEvents';
import { AuthService } from '../../services/auth.service';
import { NotificationsSidenavService } from '../../services/notifications-sidenav.service';
import { SensorEventsService } from '../../services/sensor-events.service';

@Component({
  selector: 'app-notifications-sidenav',
  templateUrl: './notifications-sidenav.component.html',
  styleUrls: ['./notifications-sidenav.component.scss']
})
export class NotificationsSidenavComponent implements OnInit, OnDestroy {
  @ViewChild('notificationsSidenav', { static: true }) public notificationsSidenav: MatSidenav
  @ViewChild('tableOnePaginator', { static: false, read: MatPaginator }) tableOnePaginator: MatPaginator;
  @ViewChild('tableTwoPaginator', { static: false, read: MatPaginator }) tableTwoPaginator: MatPaginator;
  public newData: any[] = [];
  public dismissedData: any[] = [];
  public ripple: boolean = false;

  private newNotifSub: Subscription;
  private getDismissedOrNotSub: Subscription;
  private patchSub: Subscription;
  public activateButtons: boolean = true;
  public sensorNotifications: any[] = [];
  public parkingNotifications: any[] = [];

  public sensorNotifObs: Observable<any>
  public parkingNotifObs: Observable<any>

  dataSourceSensorNotifications: MatTableDataSource<any[]>;
  dataSourceParkingNotifications: MatTableDataSource<any[]>;

  selected = new FormControl(0);

  public activateForMunicipalityPolice: boolean;
  public activateForAdminOrCustAdmin: boolean;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: LanguageService,
    public notificationsSidenavService: NotificationsSidenavService,
    private sensorEventsService: SensorEventsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.activateForAdminOrCustAdmin = this.authService.isLoggedInAndAdmin || this.authService.isLoggedInCustomerAdmin
    this.activateForMunicipalityPolice = this.authService.isLoggedInMunicipalPolice
    this.getNotificationsAndTransformForView()
    // FOR NOW until websockets ready
    // this.getDismissedOrNotSub = this.getNotificationsAndTransformForView().subscribe(res => {
    //   this.newData = [...res]
    //   this.transformNotifications(this.newData)
    // })

    this.newNotifSub = this.notificationsSidenavService.newNotification.pipe(
      map(res => res),
      mergeMap(res => res ? this.sensorEventsService.getDismissedOrNotSensorNotifications({ dismissed: false }) : [])
    ).subscribe(res => {
      this.newData = [...res]
      this.transformNotifications(this.newData)
    })

    this.newNotifSub = this.notificationsSidenavService.dismissedNotif.pipe(
      map(res => res),
      mergeMap(res => res ? this.sensorEventsService.getDismissedOrNotSensorNotifications({ dismissed: false }) : [])
    ).subscribe(res => {
      this.newData = [...res]
      this.transformNotifications(this.newData)
    })
  }

  transformNotifications(data: any[]) {
    this.changeDetectorRef.detectChanges();
    this.newData = this.newData.map(item => {
      item['battery'] = item.attributes.type === 'battery' ? true : false;
      item['prk'] = item.attributes.type === 'overtime' || item.attributes.type === 'violation' ? true : false;
      item['user_auth'] = item.attributes.type === 'user_auth' ? true : false;
      item['is_authorized'] = item.attributes.message === 'Authorized user' ? true : false;
      item['keepalive_check'] = item.attributes.type === 'keepalive_check' ? true : false;
      item['lastUpdated'] = moment(item.attributes.timestamp).fromNow()

      return item
    })
    // create two seperate objects: Sensors notifications and Parking Notifications
    this.sensorNotifications = this.newData.filter(datum => {
      if (!datum['prk'] && !datum['user_auth'] && !datum['is_authorized']) return datum
      else return
    })

    this.dataSourceSensorNotifications = new MatTableDataSource(this.sensorNotifications)
    this.dataSourceSensorNotifications.paginator = this.tableOnePaginator
    this.sensorNotifObs = this.dataSourceSensorNotifications.connect()

    this.parkingNotifications = this.newData.filter(datum => {
      if (!datum['battery'] && !datum['keepalive_check']) return datum
      else return
    })

    this.dataSourceParkingNotifications = new MatTableDataSource(this.parkingNotifications)
    this.dataSourceParkingNotifications.paginator = this.tableTwoPaginator
    this.parkingNotifObs = this.dataSourceParkingNotifications.connect()

    this.notificationsSidenavService.setNotificationsArray(this.newData)
  }

  getNotificationsAndTransformForView() {
    // FOR NOW until websockets ready
    // getNotificationsAndTransformForView(): Observable<any> {
    // return interval(60_000)
    //   .pipe(
    //     startWith(1),
    //     switchMap(val => this.sensorEventsService.getDismissedOrNotSensorNotifications({ dismissed: false })))
    this.getDismissedOrNotSub = this.sensorEventsService.getDismissedOrNotSensorNotifications({ dismissed: false }).pipe().subscribe(res => {
      this.newData = [...res]
      this.transformNotifications(this.newData)
    })
  }

  dismissedNotifications() {
    this.router.navigate(['./notifications'], { relativeTo: this.route })
    this.notificationsSidenavService.close()
  }

  unReadNotitfications() {
    this.router.navigate(['./unread-notifications'], { relativeTo: this.route })
    this.notificationsSidenavService.close()
  }

  removeItemOnce(item, value) {
    this.patchNotificationAsRead(item)
  }


  // notificationOpen(notification?: Notification, $event?, sendEmail?: boolean) {
  //   if (!sendEmail) this.notifications.splice(this.notifications.findIndex(x => x == notification), 1);

  dismissAllNotifications() {
    this.newData.map((item, index) => {
      this.newData.splice(index, 1)
      this.notificationsSidenavService.setNotificationsArray(this.newData)
      this.patchNotificationAsRead(item)
    })
    if (this.newData.length !== 0 && this.newData.length > 0) return this.dismissAllNotifications()
    else this.notificationsSidenavService.setDismissedNotif(true)
  }

  // Add model for the Notification ITEM
  patchNotificationAsRead(item) {
    this.patchSub = this.sensorEventsService.patchSensorNotifications(this.createItemToDismiss(item)).subscribe(res => {
      if (res) {
        this.newData.splice(this.newData.findIndex(x => x == item), 1)

        this.sensorNotifications = this.newData.filter(datum => {
          if (!datum['prk'] && !datum['user_auth'] && !datum['is_authorized']) return datum
          else return
        })

        // this.selected.value === 0
        //   ? this.sensorNotifications.splice(this.sensorNotifications.findIndex(x => x == item), 1)
        //   : this.parkingNotifications.splice(this.parkingNotifications.findIndex(x => x == item), 1)

        this.dataSourceSensorNotifications.data = this.sensorNotifications
        this.dataSourceSensorNotifications.paginator = this.tableOnePaginator
        this._setDataSource()

        this.sensorNotifObs = this.dataSourceSensorNotifications.connect()

        this.parkingNotifications = this.newData.filter(datum => {
          if (!datum['battery'] && !datum['keepalive_check']) return datum
          else return
        })

        this.dataSourceParkingNotifications.data = this.parkingNotifications
        this.dataSourceParkingNotifications.paginator = this.tableTwoPaginator
        this._setDataSource()

        this.parkingNotifObs = this.dataSourceParkingNotifications.connect()

        this.notificationsSidenavService.setNotificationsArray(this.newData)
        this.notificationsSidenavService.setDismissedNotif(true)
        this.notificationsSidenavService.setNotificationsArray(this.newData)
      }
    },
      err => { console.log(err) },
      () => {
        console.log('complete')
      })
  }

  createItemToDismiss(item) {
    let sensorToDismiss: NotificationDismissed = {
      data: {
        type: item.type,
        id: item.id,
        attributes: {
          dismissed: true
        }
      }
    }
    return sensorToDismiss
  }

  // removeItemAll(arr, value) {
  //   var i = 0;
  //   while (i < arr.length) {
  //     if (arr[i] === Number(value)) {
  //       arr.splice(i, 1);
  //     } else {
  //       ++i;
  //     }
  //   }
  //   console.log(arr)
  //   this.newData = [...arr]
  //   return this.newData;
  // }

  className(value, isBat?: boolean) {
    let style: string;

    if (parseFloat(value) >= 0 && parseFloat(value) <= 50.00) style = 'low'

    if (!isBat) style = `low`

    return style;
  }

  getStyleForMalfunction(isBat: boolean) {
    let style: string;
    if (isBat) style = `medium`
    if (!isBat) style = `malfunction-bg`
    return style;
  }

  _setDataSource(indexNumber?) {
    setTimeout(() => {
      switch (indexNumber) {
        case 0:
          !this.dataSourceSensorNotifications.paginator ? this.dataSourceSensorNotifications.paginator = this.tableOnePaginator : null;
          break;
        case 1:
          !this.dataSourceParkingNotifications.paginator ? this.dataSourceParkingNotifications.paginator = this.tableTwoPaginator : null;
          break;
        default:
          !this.dataSourceSensorNotifications.paginator ? this.dataSourceSensorNotifications.paginator = this.tableOnePaginator : null;
          !this.dataSourceParkingNotifications.paginator ? this.dataSourceParkingNotifications.paginator = this.tableTwoPaginator : null;
      }
    });
  }

  ngOnDestroy() {
    if (this.newNotifSub) this.newNotifSub.unsubscribe();
    if (this.getDismissedOrNotSub) this.getDismissedOrNotSub.unsubscribe();
    if (this.patchSub) this.patchSub.unsubscribe();
    this.sensorNotifications = [];
    this.parkingNotifications = [];
  }

}
